export const showAddFaqsModal = () => {
    return {
      type: "SHOW_ADD_FAQS_MODAL",
    };
  };
  
  export const hideAddFaqsModal = () => {
    return {
      type: "HIDE_ADD_FAQS_MODAL",
    };
  };
  